"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZENDESK_API_KEY = void 0;
const ZENDESK_API_KEY = {
    zendeskDefaultKey: 'e8d5f93b-f225-4ea2-b9e2-3955071e6481',
    zendeskSandboxKey: '2666a113-a2e9-423d-b68f-27ecd59eb019',
    zendeskCaKey: '8f64ed36-5603-42ff-bfdc-e4d136ad7a1a',
    zendeskEsKey: '42a57dfa-38f6-4578-b714-fbdfd5bd5e88',
    zendeskJpKey: '14baacbd-8b6e-4274-9cca-59484b4a4e39',
    zendeskUsKey: 'be4e0bec-7757-4d5b-aa21-2009785527dc',
    zendeskAuKey: 'b66cba8f-7461-4458-9f1e-9719717e6d7c',
    zendeskNzKey: '81909f06-0d0a-46c4-8cb3-e6c59427c6d0',
    zendeskChKey: 'f4cce9ed-95f9-49e0-bce0-d34004f833a8',
    zendeskDkKey: '40c3e9aa-797b-44d9-913c-0652c8635d17',
    zendeskFrDeEnKey: '798b9cc7-8f6c-4dff-a298-93dd042580a7',
    zendeskFrFrKey: '3c7ee14f-a331-4da6-8602-d15ec4e0d849',
    zendeskDeDeKey: '138e592f-7dc2-40f0-aa59-b573d335e295',
    zendeskHkKey: 'd18adf28-96bb-4b6e-a6d1-ea18c950a22e',
    zendeskItKey: 'dd54f58a-4a85-495b-95b8-41a225b22c64',
    zendeskKrKey: '8e91e019-8aab-4897-92ec-ebe8b2a70c37',
    zendeskNoKey: 'ffed92f9-ce71-4937-8127-7a08efd9f157',
    zendeskSgKey: '7673e170-5299-4798-b307-85a963177a8e',
    zendeskSeKey: 'edef5b16-0239-4a12-87cf-baeef4411185',
    zendeskTwKey: '7aa88792-49ee-4161-9df5-33f384fc01bc',
    zendeskGbKey: 'ccf26ecf-ff86-40ac-a4cb-6502bdf40b85',
};
exports.ZENDESK_API_KEY = ZENDESK_API_KEY;
//# sourceMappingURL=chat.js.map